import { wordService } from "../services/wordService";

export const applySection = () =>
  wordService.applySemanticTag({ type: "section", styleBuiltIn: "Heading1", metadata: { level: 1 } });
